import { useSelector } from 'react-redux';
import { getSelectedEditableAssignments } from '../../instruction-hub/instruction-hub-assignments';

const useSelectedAssignmentsCount = () => {
  return useSelector(
    (state) =>
      getSelectedEditableAssignments(
        state.CourseAssignReducer.assignments.studentAssignments,
        state.CourseAssignReducer.instructionHubBlockedLookup
      ).length
  );
};

export default useSelectedAssignmentsCount;



// WEBPACK FOOTER //
// ./helpers/hooks/use-selected-assignments-count/use-selected-assignments-count.js